import { render, staticRenderFns } from "./by-department.vue?vue&type=template&id=ef218ce8&scoped=true"
import script from "./by-department.vue?vue&type=script&lang=js"
export * from "./by-department.vue?vue&type=script&lang=js"
import style0 from "./by-department.vue?vue&type=style&index=0&id=ef218ce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef218ce8",
  null
  
)

export default component.exports